import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MENU_ITEMS, TopMenuItems } from "./config";
import styles from "./index.module.less";
import { Dropdown } from "@arco-design/web-react";
import MatrixDownloadModal from "@/layouts/components/MatrixDownloadModal";
import userStore from "@/stores/user";
const MyTooltip = ({ visible, children, ...props }: any) => {
  if (visible) {
    return <Dropdown {...props}>{children}</Dropdown>;
  } else {
    return children;
  }
};
const Menu = () => {
  const navigate = useNavigate();
  const [activePath, setActivePath] = useState("/work-bench");
  const location = useLocation();
  const [downloadVisible, setDownloadVisible] = useState(false);
  useEffect(() => {
    setActivePath(location.pathname);
  }, [location.pathname]);
  const getFirstName = (name) => {
    const pathname = name;
    const match = pathname.match(/^\/([^/]+)/);
    const firstValue = match ? match[1] : null;
    return firstValue;
  };
  return (
    <div className={styles.layout_sider}>
      {TopMenuItems.map((item, index) => {
        return (
          <div
            onClick={() => {
              setActivePath(item.path);
              navigate(item.path);
            }}
            className={styles.menu_top}
            key={index}
          >
            <img src={item.icon} alt="" />
            {item.label}
          </div>
        );
      })}
      {MENU_ITEMS.map((item, index) => {
        return (
          <React.Fragment key={index}>
            {
              <MyTooltip
                visible={item?.children?.length > 0}
                getPopupContainer={(e) => e.parentElement}
                droplist={
                  <div className={styles.menu_tooltip}>
                    {item?.children?.map((child, index) => {
                      return (
                        <div
                          onClick={() => {
                            if (!userStore.userInfo?.id && item.path !== "/work-bench") {
                              userStore.setIsLogin(false);
                              return;
                            }
                            if (child.path === "download") {
                              setDownloadVisible(true);
                              return;
                            }
                            child.click();
                          }}
                          className={styles.menu_item}
                          key={index}
                        >
                          <img src={child.icon} alt="" />
                          {child.label}
                        </div>
                      );
                    })}
                  </div>
                }
                position="right"
              >
                {item.type === "path" && (
                  <div
                    onClick={() => {
                      if (!userStore.userInfo?.id && item.path !== "/work-bench") {
                        userStore.setIsLogin(false);
                        return;
                      }
                      if (item.path === "/matrix") return;
                      setActivePath(item.path);
                      navigate(item.path);
                    }}
                    key={item.path}
                    className={
                      styles.menu_item + (activePath.includes(getFirstName(item.path)) ? " " + styles.active : "")
                    }
                  >
                    {activePath.includes(getFirstName(item.path)) ? (
                      <img src={item.checkIcon} alt="" />
                    ) : (
                      <img src={item.icon} alt="" />
                    )}
                    {item.label}
                  </div>
                )}
                {item.type === "line" && <div className={styles.menu_line} />}
              </MyTooltip>
            }
          </React.Fragment>
        );
      })}
      <MatrixDownloadModal visible={downloadVisible} setVisible={setDownloadVisible} />
    </div>
  );
};
export default Menu;
